// fetchAuth — helper na fetch s automatickym Bearer tokenom z localStorage
// 401 → odhlasenie (token expired/invalid) → reload na LoginScreen
// 403 → vrati response (caller rozhodne ako reagovat na role-guard)
//
// Pouzitie:
//   const r = await fetchAuth('/api/customers')
//   const j = await r.json()

const TOKEN_KEY = 'kamir_token'

export async function fetchAuth(url, opts = {}) {
  const token = localStorage.getItem(TOKEN_KEY)
  const headers = {
    ...(opts.headers || {})
  }
  if (token) headers.Authorization = `Bearer ${token}`
  // Pre POST/PUT/PATCH bez explicit Content-Type pridame JSON default
  if (opts.body && !headers['Content-Type'] && typeof opts.body === 'string') {
    headers['Content-Type'] = 'application/json'
  }

  const r = await fetch(url, { ...opts, headers })

  // pin_nevyhodi_v1 (8. 10. 2026, Mirko: „nič nech nevyhodí zlý PIN. nie sme bankový software“):
  // 401 z overovania PIN-u znamená ZLÝ PIN, nie stratenú reláciu. Odhlásiť človeka za preklep
  // v štvorčíslí je neúmerné — prišiel by o rozrobenú prácu a päť pokusov podľa ústavy 63 by si
  // ani nestihol vyskúšať. Hláška sa ukáže v okne PIN-u a dá sa zadať znova.
  const _pinTrasa = /\/api\/(pin|auth\/pin)\//.test(String(url || ''))

  // 401 = neplatny token → odhlasit + redirect na login
  if (r.status === 401 && !_pinTrasa) {
    localStorage.removeItem(TOKEN_KEY)
    // Mäkky reload — App.jsx detekuje absenciu user-a a zobrazi LoginScreen
    if (typeof window !== 'undefined') {
      window.location.reload()
    }
  }

  return r
}

// JSON helper
export async function fetchAuthJSON(url, opts = {}) {
  const r = await fetchAuth(url, opts)
  if (!r.ok) {
    let detail = ''
    try { const j = await r.json(); detail = j.error || j.message || JSON.stringify(j) } catch (_) {}
    throw new Error(`HTTP ${r.status}${detail ? ': ' + detail : ''}`)
  }
  return r.json()
}

export default fetchAuth
